import React, {useEffect, useMemo} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {includes as _includes} from 'lodash';

import HeaderRenderer from '@appComponents/HeaderRenderer';
import Tabs from '@appComponents/Tabs';
import mapModulesToProps from '@utils/mapModulesToProps';
import navigation from '@constants/navigation';
import {routes} from '@constants/routes';

import {
    createTabs,
    getSpiideoMappingsDocumentTitle,
    isSpiideoCompetitorsFormPath,
    isSpiideoVenuesFormPath,
} from '../utils/spiideoMappingsTabsLayoutHelper';
import {EXPORT_EXCEL_URL_FRAGMENT} from '@constants/variables';

export const SpiideoMappingsTabsLayout = (
    {
        match: {
            path,
        },
        Menu,
    }
) => {
    useEffect(() => {
        Menu.storeMenu(navigation.infrastructure.key);
    }, []);

    useEffect(() => {
        document.title = getSpiideoMappingsDocumentTitle(path);

        return () => {
            document.title = 'AVCMP';
        };
    }, [path]);


    const activePath = useMemo(() => {
        if (_includes([
            routes.spiideoMappings.competitors.path,
            `${routes.spiideoMappings.competitors.path}${EXPORT_EXCEL_URL_FRAGMENT}`,
        ], path) || isSpiideoCompetitorsFormPath(path)) {
            return routes.spiideoMappings.competitors.path;
        } else if (_includes([
            routes.spiideoMappings.venues.path,
            `${routes.spiideoMappings.venues.path}${EXPORT_EXCEL_URL_FRAGMENT}`,
        ], path) || isSpiideoVenuesFormPath(path)) {
            return routes.spiideoMappings.venues.path;
        } else {
            return path;
        }
    }, [path]);

    return (
        <>
            <HeaderRenderer pageTitle='Spiideo mappings'/>
            <Tabs items={createTabs(path)} active={activePath}/>
        </>
    );
};

SpiideoMappingsTabsLayout.propTypes = {
    match: PropTypes.shape({
        path: PropTypes.string.isRequired,
    }).isRequired,
    Menu: PropTypes.object.isRequired,
};
SpiideoMappingsTabsLayout.displayName = 'SpiideoMappingsTabsLayout';

export default connect(null, mapModulesToProps(['Menu']))(SpiideoMappingsTabsLayout);
